var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinShareYoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0187 17.624H14.9837C13.2201 17.624 12.08 16.4644 12.08 15.032C12.08 13.5589 13.2551 12.4399 15.0521 12.4399C16.8501 12.4399 17.9564 13.5589 17.9892 15.032C17.9909 16.4644 16.8517 17.624 15.0187 17.624ZM31.3448 34.65H36.5876V26.0586C36.5876 21.4557 33.9993 19.3138 30.5389 19.3138C27.7492 19.3138 26.5003 20.7729 25.8101 21.7922V19.6678H20.5544C20.6206 21.0699 20.5544 34.65 20.5544 34.65H25.8101V26.2827C25.8101 25.8321 25.8468 25.3825 25.9846 25.0753C26.3598 24.171 27.213 23.2385 28.6725 23.2385C30.5739 23.2385 31.3448 24.6232 31.3448 26.6366V34.65ZM25.8091 21.7933C25.7902 21.8102 25.7832 21.8251 25.7784 21.8405H25.8091V21.7933ZM17.649 34.65H12.396V19.6678H17.649V34.65Z",
    fill: "#d49830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShareYoli);
export default __webpack_public_path__ + "static/media/linkedin_shareYoli.8ba71f9f0fb9d1559d6ffdb4a2408c4d.svg";
export { ForwardRef as ReactComponent };